<template>
  <div id="contacts-table" class="data-list-container">
    <tc-table
      ref="table"
      :dataList="contacts"
      @filter="filter"
      :tbody="tbody"
      :settings="{
        externalFilters: {
          show: false
        },
        defaultDate: null,
        filters: {
          hosts: {
            type: 'checkbox',
            class: 'min-w-48',
            label: 'Only Show Hosts'
          },
          contactType: {
            type: 'v-select',
            class: 'min-w-48',
            label: 'Type',
            clearable: false,
            options: {
              text: 'name',
              value: 'id',
              items: [{
                id: '',
                name: 'All'
              }, ...((contactTypes || {}).items || [])]
            }
          },
          status: {
            type: 'v-select',
            class: 'min-w-48',
            label: 'Status',
            clearable: false,
            options: {
              text: 'name',
              value: 'id',
              items: [{
                id: '',
                name: 'All'
              }, {
                id: 'checkedin',
                name: 'Signed In'
              }, {
                id: 'checkedout',
                name: 'Signed Out'
              }]
            }
          },
        }
      }">
      <template slot="thead">
        <vs-th sort-key="name">Status</vs-th>
        <vs-th sort-key="category">Visitor Name</vs-th>
        <vs-th sort-key="category">Type</vs-th>
        <vs-th sort-key="category">Phone</vs-th>
        <vs-th sort-key="category">Email</vs-th>
        <vs-th sort-key="category">Company</vs-th>
        <vs-th>Actions</vs-th>
      </template>
    </tc-table>

    <!-- <vs-button
      v-if="contacts && contacts.items  && contacts.items.length > 0"
      style="margin-top:-3rem;"
      class="mr-auto mb-2"
      type="border"
      icon-pack="feather"
      icon="icon-download"
      icon-before
      @click="csvExport">Export Data as CSV</vs-button> -->

    <vs-button
      style="margin-top: -2rem;"
      class="mr-auto mb-2"
      icon-pack="feather"
      icon="icon-plus"
      icon-before
      @click="openFormContact">Add Contact</vs-button>
  </div>
</template>

<script>
import contactsTableBody from '@/components/tc-toble-body/Contacts.vue';
import { mapState } from 'vuex';
export default {
  components: {},
  data () {
    return {
      isMounted: false,
      tbody: {
        component: contactsTableBody,
        methods: {
          onDelete: (id) => {
            this.$refs.table.invokeFilter();
          }
        }
      }
    };
  },
  computed: {
    ...mapState('visitManagement', ['contacts', 'contactTypes'])
  },
  methods: {
    csvExport () {},
    async filter (params) {
      this.$store.dispatch('visitManagement/fetchContacts', params);
    },
    openFormContact () {
      this.$root.$tcPopup.show({
        data: {},
        classes: 'vs-dialog--lg',
        title: 'New Contact',
        component: 'FormContact',
        acceptText: 'Save'
      }).then(form => {
        try {
          form.$on('submit', result => {
            if ((result || {}).id) this.$router.push(`/contacts/${result.id}`);
          });
        } catch (error) {
          return null;
        }
      })
    }
  },
  async created () {
    await this.$store.dispatch('visitManagement/fetchContactTypes', { limit: 1000 });
  },
  mounted () {
    this.isMounted = true;
  }
};
</script>
